//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import signUpRecords from './components/signUpRecords';
import {formatDate} from '../../../src/lib/date';
import fileUploader from '../../views/common-components/file-uploader';
import ActivityBaseinfo from './components/activity-baseinfo';
import ActivitySignUp from './components/activity-signUp';
import ActivityHtmlDetail from './components/activity-html-detail';
import arrayToTree from 'array-to-tree';
import SelectCouponModal from '../coupons/components/select-coupon-modal';

export default {
    name: 'activityDetail',
    components: {
        SelectCouponModal,
        ActivityHtmlDetail,
        ActivitySignUp,
        ActivityBaseinfo,
        signUpRecords,
        fileUploader
    },
    filters: {
        formatDate(time, type) {
            var date = new Date(time);
            if (type == 1) {
                return formatDate(date, 'yyyy-MM-dd');
            }
            return formatDate(date, 'yyyy-MM-dd hh:mm');
        }
    },
    data() {
        return {
            activity: {
                signUpSetting: {}
            },
            loading: false,
            activityId: 0,
            tabName: 'name1',
            showActivityEditModal: false,
            rules: {
                activityName: {required: true, message: '请输入活动名称', trigger: 'blur'},
                activityType: {required: true, type: 'number', message: '请选择活动类型', trigger: 'change'},
                introduction: {required: true, message: '请输入活动简介', trigger: 'blur'},
                address: {required: true, message: '请输入活动地点', trigger: 'blur'}
                // startDateTime: [{ required: true, type: 'datetime', message: '请选择活动开始日期', trigger: 'change' }],
                // endDateTime: [{ required: true, type: 'datetime', message: '请选择活动结束日期', trigger: 'change' }]

            },
            saving: false,
            activityInfo: {
                file: {associateType: 'ActivityLogo'}
            },
            showContentModel: false,
            showEditSignUpModal: false,
            signUpInfo: {
                type: 0
            },
            srules: {
                // costType: { required: true, type: 'number', message: '请选择活动类型', trigger: 'change' }
            },
            classObject: {
                display: 'none'
            },
            showEditContributeModal: false,
            contributeInfo: {
                isContribute: false
            },
            content: '',
            options3: {
                disabledDate(date) {
                    return date && date.valueOf() < Date.now() - 86400000;
                }
            },
            cityList: [],
            projectList: [],
            projectId: 0,
            projectStageList: [],
            indeterminate: true,
            checkAll: false,
            checkAllGroup: [],
            signUpSetting: {
                activityId: 0
            },
            stagesName: '',
            showTreeModal: false,
            projectTree: [],
            selectList: [],
            couponSetting: {},
            couponRules: {
                // couponName: [{ required: true, message: '请选择优惠券', trigger: 'blur' }]
                // activityName: [{ required: true, message: '请选择活动', trigger: 'blur' }]
            },
            showSelectCouponModel: false,
            showCouponSettingModel: false
        };
    },
    methods: {
        getActivity() {
            this.loading = true;
            var vm = this;
            vm.$store.dispatch({
                type: 'activity/getActivityById',
                id: vm.activityId
            }).then(() => {
                vm.activity = vm.$store.state.activity.activityInfo;


            }).finally(() => {
                vm.loading = false;
            });
        },
        delActivity() {
            const vm = this;
            this.$Modal.confirm({
                title: this.L('Tips'),
                content: '确认删除' + vm.activity.activityName + '吗？',
                okText: this.L('Yes'),
                cancelText: this.L('No'),
                onOk: async () => {
                    await this.$store.dispatch({
                        type: 'activity/delete',
                        data: vm.activity.id
                    });
                    vm.$router.go(-1);
                }
            });
        },
        editActivity() {
            // const vm = this;
            // this.$router.push({
            //     name: 'activityEdit',
            //     params: {
            //         id: vm.activity.id
            //     }
            // });
            // this.activityInfo = JSON.parse(JSON.stringify(this.activity));
            // this.activityInfo.file = { associateType: 'ActivityLogo' };
            // // this.activityInfo.isLimit = true;
            // this.saving = false;
            // this.showActivityEditModal = true;
            // this.$refs.activityBaseInfoRef.editActivity();
            this.$router.push({
                name: 'activityEdit',
                params: {
                    id: this.activityId
                }
            });
        },
        onReleaseActivity(s) {
            const vm = this;
            var tit = '';
            if (s == 0) {
                tit = '确认取消发布吗？';
            } else {
                tit = '确认发布吗？';
            }
            this.$Modal.confirm({
                title: this.L('Tips'),
                content: tit,
                okText: this.L('Yes'),
                cancelText: this.L('No'),
                onOk: async () => {
                    //if (vm.activity.activityStatus === 0) {
                    vm.saving = true;
                    abp.ajax.post('/api/services/app/Activity/ChangeActivityStatus', {
                        id: vm.activity.id,
                        status: s
                    }).then(() => {
                        this.$Notice.success({
                            duration: 3,
                            title: '发布成功'
                        });
                        vm.getActivity();
                    }).finally(() => {
                        vm.saving = false;
                    });
                }
            });
            //}
        },
        onTabsClick(n) {
            if (n === 'name1') {
                // console.log(n);
            }
            this.tabName = n;
            this.showContentModel = false;
            this.showEditSignUpModal = false;
            this.$refs.contentRef.closeContentEdit();
        },
        cancel() {
            this.saving = false;
            this.showActivityEditModal = false;
        },
        onSave() {
            var vm = this;
            if (!vm.activityInfo.startDateTime) {
                abp.message.error('请输入活动开始时间');
                return;
            }
            if (!vm.activityInfo.endDateTime) {
                abp.message.error('请输入活动结束时间');
                return;
            }
            if (!vm.activityInfo.isLimit) {
                this.activityInfo.totalNum = '';
            }
            this.$refs.activityForm.validate(async (val) => {
                if (val) {
                    vm.saving = true;
                    vm.$store.dispatch({
                        type: 'activity/saveActivity',
                        data: vm.activityInfo
                    }).then(() => {
                        vm.$Notice.success({
                            duration: 3,
                            title: '保存成功'
                        });
                        vm.showActivityEditModal = false;
                        vm.getActivity();
                    }).finally(() => {
                        vm.saving = false;
                    });
                }
            });
        },
        showEditContent() {
            this.showContentModel = true;
            this.$refs.contentRef.showContentEdit();
        },
        onSaveContent() {
            this.showContentModel = false;
            this.$refs.contentRef.onSaveActivityContent();
        },
        showEditSignUp() {
            var vm = this;
            this.showEditSignUpModal = true;
            this.signUpInfo = {
                isSignUp: false,
                type: 0
            };
            //
            if (this.activity.isSignUp) {
                this.signUpInfo.isSignUp = this.activity.isSignUp;
                this.signUpInfo.signUpPoint = this.activity.signUpPoint;
                this.signUpInfo.signUpStartTime = this.activity.signUpStartTime;
                this.signUpInfo.signUpEndTime = this.activity.signUpEndTime;
                this.signUpInfo.costType = this.activity.costType;
                this.signUpInfo.signUpCost = this.activity.signUpCost;
                this.signUpInfo.signUpCost = this.activity.signUpCost;
                this.signUpInfo.isSignIn = this.activity.isSignIn;
                this.signUpInfo.signInPoint = this.activity.signInPoint;
                this.signUpInfo.couponId = this.activity.couponId;
                this.signUpInfo.couponName = this.activity.couponName;
            }

        },
        onSaveSignUpSetting() {
            /////
            this.signUpSetting.activityId = this.activityId;
            this.signUpSetting.memberStr = this.checkAllGroup.toString();
            this.signUpSetting.stagesName = this.stagesName;
            /////
            var vm = this;
            this.signUpInfo.activityId = this.activityId;
            if (vm.signUpInfo.isSignUp) {
                if (!vm.signUpInfo.signUpStartTime && vm.signUpInfo.isSignUp) {
                    abp.message.error('请输入报名开始时间');
                    return;
                }
                if (!vm.signUpInfo.signUpEndTime && vm.signUpInfo.isSignUp) {
                    abp.message.error('请输入报名结束时间');
                    return;
                }

                if (vm.signUpInfo.costType == undefined) {
                    abp.message.error('请输入费用模式');
                    return;
                }
            }
            var page = {};
            if (!vm.signUpInfo.isSignUp) {
                page = {};
                page.isSignUp = false;
            } else {
                page = vm.signUpInfo;
            }
            page.activityId = vm.activityId;
            // vm.$refs.signUpForm.validate(async (val) => {
            //     console.log('1111111111');
            //     console.log(val);
            //     if (val) {
            vm.saving = true;
            vm.$store.dispatch({
                type: 'activity/saveSignUpSettings',
                data: page
            }).then(() => {
                vm.$Notice.success({
                    duration: 3,
                    title: '保存成功'
                });
                vm.showEditSignUpModal = false;
                vm.getActivity();
            }).finally(() => {
                vm.saving = false;
            });
            //     }
            // });
        },
        showEditContribute() {
            var vm = this;
            vm.contributeInfo = {};
            if (vm.activity.isContribute) {
                vm.contributeInfo.isContribute = vm.activity.isContribute;
                // vm.contributeInfo.isContribute = JSON.parse(JSON.stringify(this.activity.isContribute));
                vm.contributeInfo.contributePoint = vm.activity.contributePoint;
                vm.contributeInfo.contributeStartTime = vm.activity.contributeStartTime;
                vm.contributeInfo.contributeEndTime = vm.activity.contributeEndTime;
                vm.contributeInfo.isVote = vm.activity.isVote;
                vm.contributeInfo.votePoint = vm.activity.votePoint;
                vm.contributeInfo.voteStartTime = vm.activity.voteStartTime;
                vm.contributeInfo.voteEndTime = vm.activity.voteEndTime;
            }
            vm.showEditContributeModal = true;
        },
        onSaveEditContribute() {
            var vm = this;
            var page = {};

            if (!vm.contributeInfo.isContribute) {
                page = {};
                page.contributeInfo = false;
            } else {
                page = vm.contributeInfo;
            }
            page.activityId = vm.activityId;

            // vm.$refs.contributeForm.validate(async (val) => {
            //     if (val) {
            vm.saving = true;
            vm.$store.dispatch({
                type: 'activity/saveContributeSettings',
                data: page
            }).then(() => {
                vm.$Notice.success({
                    duration: 3,
                    title: '保存成功'
                });
                vm.showEditContributeModal = false;
                vm.getActivity();

            }).finally(() => {
                vm.saving = false;
            });
            // });
            //}
        },
        onSaveContributeComplete(s) {
            // console.log('s'+s)
            this.saving = false;
            if (s == 'true') {
                this.showEditContributeModal = false;
                this.getActivity();
            }
        },
        showAddACoupon() {
            this.showSelectCouponModel = true;
        },
        showCouponSetting(c) {
            this.couponSetting = {};
            this.couponSetting = c;
            this.showCouponSettingModel = true;
        },
        addCoupon(data) {
            // console.log(data);
            this.signUpInfo.couponName = data.name;
            this.signUpInfo.couponId = data.id;
            this.signUpInfo.businessType = 'Activity';
            this.showSelectCouponModel = false;
        },
        cancelChoiceCoupon() {
            this.signUpInfo.couponName = '';
            this.signUpInfo.couponId = 0;
            console.log(this.signUpInfo.couponName);
        },
        onCouponSettingSave() {
            // this.$refs.couponForm.validate(async (val) => {
            //     if (val) {
            // console.log(this.couponSetting);
            this.couponSetting.businessType = 'Activity';
            this.couponSetting.eventId = this.activity.id;

            if (this.couponSetting.couponId > 0) {
                this.saving = true;
                abp.ajax.post('/api/services/app/EventCoupon/Add', this.couponSetting).then(res => {
                    this.showEditCouponSettingModel = false;
                    this.getActivity();
                }).finally(() => {
                    this.saving = false;
                });
            } else {
                this.showEditCouponSettingModel = false;
            }
            //     }
            // });
        },
        hasPermission(permission) {
            return abp.auth.isGranted(permission);
        },

        // getProjectStagesTree() {
        //     abp.ajax.get('/api/services/app/Project/GetProjectStagesTree').then(res => {
        //         // this.getActivity();
        //
        //         this.projectTree = [];
        //         this.projectTree = res.data.result.items;
        //         this.projectTree.forEach((item, index) => {
        //             item.title = item.name;
        //             item.children = item.projects;
        //             item.type = 'city';
        //             item.children.forEach(item => {
        //                 item.children = item.stages;
        //                 item.parentId = item.cityId;
        //                 item.type = 'project';
        //                 item.children.forEach(i => {
        //                     i.parentId = i.projectId;
        //                     i.type = 'fenqi';
        //                 });
        //             });
        //         });
        //
        //         this.projectTree = arrayToTree(this.projectTree, {
        //             parentProperty: 'parentId',
        //             customID: 'id'
        //         });
        //     }).finally(() => {
        //         // this.saving = false;
        //     });
        // },
        // onSelectTree() {
        //     this.$refs.treeRef.getCheckedNodes();
        //     console.log('---------------------------------------------');
        //     console.log(this.$refs.treeRef.getCheckedAndIndeterminateNodes());
        //     var list = this.$refs.treeRef.getCheckedAndIndeterminateNodes();
        //
        //     var index = list.findIndex(x => x.type === 'city');
        //     this.selectList = [];
        //     var select = list.filter(x => x.type === 'city');
        //     select.forEach(city => {
        //         this.selectList.push({
        //             id: city.id,
        //             name: city.title,
        //             isAll: city.checked
        //         });
        //     });
        //     for (var i = 0; i < this.selectList.length; i++) {
        //         this.selectList[i].sssss = [];
        //         var s1 = list.filter(x => x.cityId === this.selectList[i].id);
        //
        //         var sss = [];
        //         s1.forEach(project => {
        //             sss.push({
        //                 id: project.id,
        //                 name: project.title,
        //                 cityId: project.cityId,
        //                 isAll: project.checked
        //                 // projectId: item.projectId
        //             });
        //         });
        //
        //         this.selectList[i].sssss = sss;
        //
        //         for (var j = 0; j < this.selectList[i].sssss.length; j++) {
        //             this.selectList[i].sssss[j].ddddd = [];
        //             var s2 = list.filter(x => x.projectId === this.selectList[i].sssss[j].id);
        //
        //             var ssss = [];
        //             s2.forEach(s => {
        //                 ssss.push({
        //                     id: s.id,
        //                     name: s.title,
        //                     projectId: s.projectId
        //                 });
        //             });
        //             this.selectList[i].sssss[j].ddddd = ssss;
        //         }
        //
        //     }
        //     console.log('---------------------------------------------1');
        //     console.log(this.selectList);
        //     console.log('---------------------------------------------1');
        // }

    },
    created() {
        this.activityId = parseInt(this.$route.params.id || 0);
        this.tabName = 'name1';
        if (this.activityId > 0) {
            this.getActivity();
            this.contributeInfo.activityId = this.activityId;

        }
    },
    watch: {}
};
